'use strict';
/* global jQuery */
/* global require */
const util = require('util');

angular
  .module('banners')
  .component('banners', {
    template: require('./banners.template.html'),
    controller: ['$rootScope', '$scope', '$resource', '$translate', 'AuthService', 'envService', 'Upload',
      function BannersController($rootScope, $scope, $resource, $translate, AuthService, envService, Upload) {
        const APIURL = envService.read('apiUrl');

        $rootScope.mainmenu = 'service';
        $rootScope.menu = 'banners';

        this.doLogout = $rootScope.gLogout;
        this.loginMember = AuthService.loginMember();
        this.isLevel2Auth = AuthService.isLevel2Authenticated();
        this.homeBanners = [];
        this.slideDelaySec = 4;
        this.editBanner = undefined;
        this.editBannerIndex = -1;

        this._normalizeSlideDelay = (value) => {
          const n = Number(value);
          if (!Number.isFinite(n)) return 4;
          return Math.min(60, Math.max(0, Math.round(n)));
        };

        this.loadHomeBanners = () => {
          $resource(`${APIURL}/admin/services/apps/banners`)
            .get()
            .$promise
            .then((data) => {
              this.slideDelaySec = this._normalizeSlideDelay(data.slide_delay_sec);
              this.homeBanners = (data.banners || []).map((b) => Object.assign({}, b, {
                enabled: this._bannerEnabled(b.enabled),
              }));
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };
        this._bannerEnabled = (value) => {
          if (value === false || value === 0 || value === '0') return false;
          if (typeof value === 'string') {
            const v = value.trim().toLowerCase();
            if (v === 'false' || v === 'off' || v === 'no' || v === '') return false;
          }
          return value !== false;
        };

        this.loadHomeBanners();

        this.showBannerModal = (banner) => {
          if (!this.isLevel2Auth) {
            return;
          }
          if (banner) {
            this.editBannerIndex = this.homeBanners.indexOf(banner);
            this.editBanner = JSON.parse(JSON.stringify(banner));
          } else {
            this.editBannerIndex = -1;
            this.editBanner = {
              id: null,
              country: 'TH',
              title: '',
              description: '',
              image_url: '',
              link_url: '',
              local_key: '',
              enabled: true,
            };
          }
          jQuery('#modal-home-banner').modal('show');
        };

        this.uploadBannerImage = (files) => {
          if (!files || !files.length) {
            return;
          }
          const file = files[0];
          Upload.upload({
            url: `${APIURL}/admin/file/banners`,
            file,
          }).success((data) => {
            if (data && data.url) {
              // New file name + cache-bust; drop bundled local_key so apps never show old art
              const sep = data.url.indexOf('?') >= 0 ? '&' : '?';
              this.editBanner.image_url = `${data.url}${sep}v=${Date.now()}`;
              this.editBanner.local_key = '';
            }
          }).error((err) => {
            console.error(err);
            alert($translate.instant('알수 없는 에러 입니다.'));
          });
        };

        this.applyBannerModal = () => {
          if (!this.editBanner.link_url && !this.editBanner.image_url) {
            alert(util.format($translate.instant('%s를(을) 입력해주세요.'), $translate.instant('링크')));
            return;
          }
          const item = Object.assign({}, this.editBanner, {
            enabled: this._bannerEnabled(this.editBanner.enabled),
            sort: this.editBannerIndex >= 0 ? this.editBannerIndex : this.homeBanners.length,
            local_key: this.editBanner.image_url ? '' : (this.editBanner.local_key || ''),
          });
          if (this.editBannerIndex >= 0) {
            this.homeBanners[this.editBannerIndex] = item;
          } else {
            if (!item.id) {
              const maxId = this.homeBanners.reduce((m, b) => Math.max(m, Number(b.id) || 0), 0);
              item.id = maxId + 1;
            }
            this.homeBanners.push(item);
          }
          jQuery('#modal-home-banner').modal('hide');
          // Persist immediately so OFF/ON reaches apps without a second Save click
          this.saveHomeBanners(true);
        };

        this.deleteBanner = (banner) => {
          if (!this.isLevel2Auth) {
            return;
          }
          if (!confirm($translate.instant('정말로 삭제하시겠습니까?'))) {
            return;
          }
          const idx = this.homeBanners.indexOf(banner);
          if (idx >= 0) {
            this.homeBanners.splice(idx, 1);
          }
        };

        this.saveHomeBanners = (silent) => {
          if (!this.isLevel2Auth) {
            return;
          }
          if (!silent && !confirm($translate.instant('홈 배너를 저장하시겠습니까?'))) {
            return;
          }
          this.slideDelaySec = this._normalizeSlideDelay(this.slideDelaySec);
          const payload = {
            slide_delay_sec: this.slideDelaySec,
            banners: this.homeBanners.map((b, i) => Object.assign({}, b, {
              sort: i,
              enabled: this._bannerEnabled(b.enabled),
            })),
          };
          const BannerRes = $resource(`${APIURL}/admin/services/apps/banners`, {}, {
            update: { method: 'PUT' },
          });
          BannerRes.update(payload)
            .$promise
            .then((data) => {
              this.slideDelaySec = this._normalizeSlideDelay(
                data.slide_delay_sec != null ? data.slide_delay_sec : payload.slide_delay_sec
              );
              this.homeBanners = (data.banners || payload.banners).map((b) => Object.assign({}, b, {
                enabled: this._bannerEnabled(b.enabled),
              }));
              if (!silent) {
                alert($translate.instant('수정되었습니다.'));
              }
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/service/banners/banners.component.js